import { useQuery } from "@tanstack/react-query";
import { useAuthenticatedRequest } from "hooks/useRequests";
import { CardTitle, ExcellentNonGameCondition, SportCategory, UngradedStatus } from "models/cardIngestion";

export const NewCardId = '00000000-0000-0000-0000-000000000000';

const NewCardTemplate: CardTitle = {
    id: NewCardId,
    title: '',
    category: SportCategory,
    subCategory: '',
    conditionId: ExcellentNonGameCondition.id,
    conditionName: ExcellentNonGameCondition.name,
    gradeId: null,
    gradeName: null,
    gradingCompanyId: null,
    gradingCompanyName: null,
    statusId: UngradedStatus.id,
    statusName: UngradedStatus.name,
    notes: null,
    isLot: false,
    photos: [],
    doNotUpload: false,
    doNotUploadReason: null,
    cardFolderId: '',
    folderName: '',
    folderCompleted: 0,
    folderTotal: 0,
    multiPackageFolder: false,
    packageId: null,
    packageFriendlyId: null,
    completed: false,
    owners: [],
    locked: false,
    validationErrors: null,
    packageReceivedDate: null,
    batchCanChange: false
};

const useCardTitle = (cardId: string | null, enabled: boolean) => {
    const get = useAuthenticatedRequest<CardTitle>({
        method: "get",
        url: `/card-titling/cards/${cardId}`
    });

    return useQuery(["card-titling", "cards", cardId], async () => {
        if (cardId === NewCardId) {
            return NewCardTemplate;
        }

        return await get()
    }, {
        suspense: true,
        enabled: cardId !== null && enabled,
    });
}

export default useCardTitle;